import servise from '@/router/axios'

export const fetchDspSlotList = (params) => {
  return servise({
    url: '/Dsp/getDspSlot',
    method: 'get',
    params
  })
}

export const getDspSlot = (dspSlotId) => {
  return servise({
    url: '/Dsp/getOnDspSlot',
    method: 'get',
    params: { dspSlotId: dspSlotId }
  })
}

export const addDspSlot = (data) => {
  return servise({
    url: '/Dsp/addDspSlot',
    method: 'post',
    data
  })
}

export const updateDspSlot = (data) => {
  return servise({
    url: '/Dsp/updateDspSlot',
    method: 'PUT',
    data
  })
}

export const deleteSlot = (data) => {
  return servise({
    url: '/Dsp/delete/Dsp/flow',
    method: 'delete',
    data
  })
}

export const getRouteAddress = (params) => {
  return servise({
    url: '/slot/dsp/route/address',
    method: 'get',
    params
  })
}